import { MasterConfigContext } from "@/context/MasterConfigContext";
import { useContext } from "react";

const CandidateStatusWidget = ({state="पश्चिम बंगाल"}) => {
  
    const masterconfig = useContext(MasterConfigContext);
    const widgetKey = masterconfig?.["assembly_widgets_2026"]?.["keyCadidates"];
    if(!widgetKey || !state){
      return null;
    }
    const selectTally = () => {
      return widgetKey[state];
    };
  
    const tallyUrl =  selectTally()
  
    return (
      <div className="bg-gray-100 p-4 mx-4 md:mx-2 rounded-lg my-4 md:w-1/2">
        <div className="flex gap-1 items-center">
          <div className="w-8 h-8">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 mr-2"
            >
              <title>states</title>
              <g id="vuesax/linear/global-search">
                <g id="global-search">
                  <g id="Group">
                    <path
                      id="Vector"
                      d="M18.3337 10.0001C18.3337 5.40008 14.6003 1.66675 10.0003 1.66675C5.40033 1.66675 1.66699 5.40008 1.66699 10.0001C1.66699 14.6001 5.40033 18.3334 10.0003 18.3334"
                      stroke="currentColor"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      id="Vector_2"
                      d="M6.66667 2.5H7.5C5.875 7.36667 5.875 12.6333 7.5 17.5H6.66667"
                      stroke="currentColor"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      id="Vector_3"
                      d="M12.5 2.5C13.3083 4.93333 13.7167 7.46667 13.7167 10"
                      stroke="currentColor"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      id="Vector_4"
                      d="M2.5 13.3333V12.5C4.93333 13.3083 7.46667 13.7167 10 13.7167"
                      stroke="currentColor"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      id="Vector_5"
                      d="M2.5 7.5C7.36667 5.875 12.6333 5.875 17.5 7.5"
                      stroke="currentColor"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </g>
                  <g id="Group_2">
                    <path
                      id="Vector_6"
                      d="M15.1667 17.8334C16.6394 17.8334 17.8333 16.6394 17.8333 15.1667C17.8333 13.6939 16.6394 12.5 15.1667 12.5C13.6939 12.5 12.5 13.6939 12.5 15.1667C12.5 16.6394 13.6939 17.8334 15.1667 17.8334Z"
                      stroke="currentColor"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      id="Vector_7"
                      d="M18.3333 18.3333L17.5 17.5"
                      stroke="currentColor"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <h2 className="text-md font-semibold mb-2 -ml-2 mt-1">
            {"निर्वाचन क्षेत्रवार परिणाम 2021"}
          </h2>
        </div>
        <iframe
          frameborder="0"
          scrolling="no"
          mozallowfullscreen=""
          height={415}
          src={tallyUrl}
          webkitallowfullscreen=""
          width="100%"
        ></iframe>
      </div>
    )
}

export default CandidateStatusWidget